/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Field_TakenInputs */

const es_co2_error_field_taken = /** @type {(inputs: Error_Field_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este valor ya está en uso.`)
};

/**

* @param {Error_Field_TakenInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_field_taken = /** @type {((inputs?: Error_Field_TakenInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Field_TakenInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_field_taken(inputs)
});